// extracted by mini-css-extract-plugin
module.exports = {"supportFaq":"faqs_supportFaq__wOtUu"};